import { ClipboardTextClockIcon } from './ClipboardTextClockIcon';

/**
 * author: Michael Irigoyen
 * id EEFDB836-DFC2-43ED-9246-05B972EA2B57
 * name clipboard-text-clock
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-text-clock.svg
 * tags
 * - Date / Time 
 */
export const ClipboardTextHistoryIcon = ClipboardTextClockIcon;
export default ClipboardTextHistoryIcon